export default __webpack_public_path__ + "static/media/icon_radio_button_unchecked_dark.5cb4a0c3.svg";